// Officielt indhold for KEPP website (Danish). Tekster fra kundens dokument (Tekster.docx).
// Billeder er illustrative (Ecophon), hostet lokalt, og viser ikke projekter udført af Kepp & Co.

const img = (name) => `/images/${name}.jpg`;

export const images = {
  lab: img('lab'),
  factory: img('factory'),
  office: img('office'),
  openOffice: img('openOffice'),
  officeLounge: img('officeLounge'),
  lobby: img('lobby'),
  hospital: img('hospital'),
  cleanRoom: img('cleanRoom'),
  dataCentre: img('dataCentre'),
  panels: img('panels'),
  school: img('school'),
  sterile: img('sterile'),
  panelsColour: img('panelsColour'),
  varsoCafe: img('varsoCafe'),
  varsoWorkstations: img('varsoWorkstations'),
  varsoPanels: img('varsoPanels'),
  varsoLounge: img('varsoLounge'),
  varsoBoard: img('varsoBoard'),
};

export const contact = {
  company: 'Kepp & Co.',
  address: 'Meterbuen 6, Bygning 9',
  zip: '2740 Skovlunde',
  email: 'mail@kepp-co.dk',
  phone: '60 10 10 25',
  phoneRaw: '004560101025',
  cvr: '35232931',
  jobEmail: 'mail@kepp-co.dk',
  ean: '5797203064025',
  paymentTerms: 'Løbende måned + 30 dage',
};

export const people = [
  { name: 'Tobias Prins', title: 'Direktør', email: 'Tobias@kepp-co.dk', phone: '60 10 10 25', phoneRaw: '004560101025' },
  { name: 'Mathias Opstrup', title: 'Daglig drift', email: 'Mathias@kepp-co.dk', phone: '60 80 79 99', phoneRaw: '004560807999' },
];

// label = fuld (footer), short = kort (top-menu)
export const nav = [
  { label: 'Om Kepp & Co.', short: 'Om Kepp', path: '/om-kepp' },
  { label: 'Fagentreprise', short: 'Fagentreprise', path: '/fagentreprise' },
  { label: 'Asset Managers & pensionskasser', short: 'Asset Managers', path: '/asset-managers' },
  { label: 'Hovedentreprenører', short: 'Hovedentreprenører', path: '/hovedentreprenorer' },
  { label: 'Dokumentation & kvalitetssikring', short: 'Dokumentation', path: '/dokumentation-kvalitet' },
  { label: 'Kontakt', short: 'Kontakt', path: '/kontakt' },
];

/* ---------------- FORSIDE ---------------- */

export const hero = {
  eyebrow: 'Fagentreprenør · Sjælland',
  title: 'Systemlofter, gipsvægge og akustikplader til større byggerier',
  subtitle:
    'Vi udfører fagentrepriser for hovedentreprenører og professionelle bygherrer med styr på tegninger, koordinering og kvalitetssikring fra første registrering til endelig aflevering.',
  image: images.office,
  cta1: { label: 'Se vores fagområder', path: '/fagentreprise' },
  cta2: { label: 'Start en projektdialog', path: '/kontakt' },
};

export const introStatement =
  'Hos Kepp & Co. arbejder vi ikke for alle, og vi siger ikke ja til alt. Vi samarbejder med professionelle aktører i byggeriet, hvor fejl ikke er en mulighed, og hvor helhedsforståelse, struktur og handlekraft er afgørende for resultatet.';

export const uspSection = {
  eyebrow: 'Derfor Kepp & Co.',
  title: 'Vi tager ansvar for mere end udførelsen',
  image: images.varsoCafe,
  items: [
    { no: '01', text: 'Vi forstår tegningerne, processen og projektets helhed.' },
    {
      no: '02',
      text: 'Vi kombinerer teknisk forståelse og erfaring med den handlekraft, projektet kræver.',
    },
    {
      no: '03',
      text: 'Vi kvalitetssikrer hele vejen fra første registrering til endelig aflevering.',
    },
  ],
};

export const stats = [
  { value: 'Sjælland', label: 'Primært geografisk fokus' },
  { value: '3', label: 'Specialiserede fagområder' },
  { value: 'Én fast projektleder', label: 'Gennem hele entreprisen' },
  { value: 'Fra start til slut', label: 'Dokumenteret kvalitetssikring' },
];

export const disciplinesSection = {
  eyebrow: 'Fagentreprise',
  title: 'Tre fagområder. Én ansvarlig fagentreprenør.',
  cta: { label: 'Se vores fagområder', path: '/fagentreprise' },
};

export const disciplines = [
  {
    no: '01',
    title: 'Systemlofter',
    short:
      'Systemlofter udført efter projektets tegninger og specifikationer med præcis montage og styr på detaljerne.',
    long:
      'Vi udfører systemlofter efter projektets tegninger og specifikationer med præcis montage, korrekt tilpasning og tæt koordinering med byggeriets øvrige fag.',
    image: images.lab,
  },
  {
    no: '02',
    title: 'Gipsvægge',
    short:
      'Gipsvægge udført med blik for konstruktionen og koordineringen med byggeriets øvrige fag.',
    long:
      'Vi udfører gipsvægge efter projektets tegninger med fokus på konstruktion, tolerancer samt de specificerede krav til lyd og brand.',
    image: images.openOffice,
  },
  {
    no: '03',
    title: 'Akustikplader',
    short:
      'Akustikplader monteret med fokus på korrekt udførelse, præcise afslutninger og det ønskede arkitektoniske udtryk.',
    long:
      'Vi monterer akustikplader efter projektets tegninger og specifikationer med fokus på præcis placering, korrekt udførelse og samspillet med rummets øvrige elementer.',
    image: images.panelsColour,
  },
];

export const environments = {
  eyebrow: 'Professionelt byggeri',
  title: 'Miljøer med høje krav til udførelsen',
  subtitle:
    'Systemlofter, gipsvægge og akustikplader indgår i mange typer byggerier, hvor funktion, præcision og dokumenteret kvalitet er afgørende.',
  note: 'Billederne er illustrative og viser ikke projekter udført af Kepp & Co.',
  categories: [
    { title: 'Kontor & erhverv', image: images.varsoPanels },
    { title: 'Sundhedsbyggeri', image: images.hospital },
    { title: 'Rene miljøer', image: images.cleanRoom },
    { title: 'Uddannelse & institutioner', image: images.school },
  ],
};

export const closingCta = {
  title: 'Skal vi være fagentreprenør på jeres næste projekt?',
  label: 'Kontakt Kepp & Co.',
  path: '/kontakt',
};

export const footer = {
  description:
    'Fagentreprenør i systemlofter, gipsvægge og akustikplader til hovedentreprenører og professionelle bygherrer på Sjælland.',
  tagline: 'Faglighed · Dokumentation · Leverancesikkerhed',
};

/* ---------------- OM OS ---------------- */

export const aboutPage = {
  hero: { eyebrow: 'Om Kepp & Co.', title: 'Fagentreprenør med blik for helheden', image: images.openOffice },
  approach: {
    eyebrow: 'Vores tilgang',
    title: 'Vi arbejder ikke for alle, og vi siger ikke ja til alt.',
    paragraphs: [
      'Hos Kepp & Co. udfører vi systemlofter, gipsvægge og akustikplader for professionelle aktører i byggeriet, hvor kravene til dokumentation, proces og leverancesikkerhed er høje, og hvor fejl ikke er en mulighed.',
      'Vi forstår tegningerne, helheden og den kommercielle virkelighed bag projekterne. Derfor tager vi ansvar for mere end selve udførelsen. Vi bidrager til samspillet, fremdriften og kvaliteten gennem hele vores entreprise. Når kompleksiteten stiger, og koordineringen bliver afgørende, træder vi til med teknisk indsigt, struktur og handlekraft.',
      'Vores arbejde bygger på faglig stolthed og systematik. Kvalitetssikring, dokumentation og sikkerhed er integreret fra første registrering til endelig aflevering. Vi arbejder transparent med faste projektledere og klare forventninger fra start.',
      'Det gør os til en fagentreprenør for hovedentreprenører og professionelle bygherrer, der ønsker forudsigelighed, teknisk dybde og respekt for både drift, økonomi og relationer.',
    ],
  },
  principles: {
    eyebrow: 'Vores principper',
    title: 'Sådan arbejder vi',
    items: [
      {
        title: 'Faglig stolthed',
        text: 'Vi arbejder systematisk og med respekt for håndværket i hver eneste detalje.',
      },
      {
        title: 'Åbenhed',
        text: 'En fast projektleder sikrer tydelig kommunikation, klare aftaler og løbende forventningsafstemning.',
      },
      {
        title: 'Ansvar',
        text: 'Vi tager ansvar for vores entreprise og bidrager aktivt til samspillet med projektets øvrige fag.',
      },
      {
        title: 'Leverancesikkerhed',
        text: 'Vi lover realistisk, planlægger grundigt og følger vores aftaler til dørs.',
      },
    ],
  },
  quote: {
    text: 'Kvalitetssikring, dokumentation og sikkerhed er ikke noget, vi tilføjer til sidst. Det er en integreret del af vores arbejde fra første registrering til endelig aflevering.',
    ctaLabel: 'Læs om dokumentation & kvalitetssikring',
    ctaPath: '/dokumentation-kvalitet',
    image: images.lab,
  },
};

/* ---------------- FAGENTREPRISE ---------------- */

export const fagentreprisePage = {
  hero: {
    eyebrow: 'Fagentreprise',
    title: 'Systemlofter, gipsvægge og akustikplader',
    image: images.office,
  },
  intro:
    'Vi fokuserer på det, vi er gode til: systemlofter, gipsvægge og akustikplader i professionelt byggeri. Vi går gerne ind tidligt i processen og bidrager til afklaring af detaljer og koordinering mellem bygherre, rådgivere og øvrige faggrupper.',
  cta: {
    title: 'Skal vi være fagentreprenør på jeres næste projekt?',
    label: 'Kontakt Kepp & Co.',
    path: '/kontakt',
  },
};

/* ---------------- SEGMENTER ---------------- */

export const assetManagersPage = {
  eyebrow: 'Professionelle bygherrer',
  title: 'Fagentreprise for Asset Managers og pensionskasser',
  image: images.lobby,
  focusLabel: 'Vores fokus',
  intro:
    'For Asset Managers og pensionskasser med porteføljer af større erhvervs- og kontorejendomme på Sjælland leverer vi fagentrepriser med dokumenteret kvalitet, forudsigelighed og en klar proces, så beslutninger, økonomi og fremdrift kan dokumenteres og kommunikeres videre i organisationen.',
  prioritiesHeading: 'Det kan I forvente af os',
  priorities: [
    {
      title: 'Dokumenteret kvalitet',
      text: 'Sporbar kvalitetssikring fra første registrering til endelig aflevering.',
    },
    {
      title: 'Dokumentation til ESG og compliance',
      text: 'Struktureret dokumentation, der kan indgå i jeres rapportering, kvalitetssikring og interne kontrol.',
    },
    {
      title: 'Forudsigelighed i udførelsen',
      text: 'Realistiske tidsplaner, klare aftaler og tidlig varsling, så driftsforstyrrelser og uforudsete omkostninger begrænses.',
    },
    {
      title: 'Fast kontakt og kontinuitet',
      text: 'En fast projektleder, stabile teams og tydelig status gennem hele entreprisen.',
    },
  ],
  ctaHeading:
    'Søger I en fagentreprenør, der forstår både projektet og den efterfølgende drift?',
  ctaLabel: 'Book en projektdialog',
  ctaPath: '/kontakt',
};

export const contractorsPage = {
  eyebrow: 'Til hovedentreprenører',
  title: 'Fagentreprise med styr på tegninger, koordinering og fremdrift',
  image: images.factory,
  focusLabel: 'Vores fokus',
  intro:
    'For hovedentreprenører, der har brug for en fagentreprenør, som møder forberedt, holder tempoet og tager ansvar. Vi bringer teknisk forståelse og handlekraft ind på byggepladsen, så vores entreprise spiller sammen med de øvrige fag og understøtter den samlede tidsplan.',
  prioritiesHeading: 'Det kan I forvente af os',
  priorities: [
    {
      title: 'Forberedt fra start',
      text: 'Vi gennemgår tegninger, grænseflader og kritiske detaljer, før udførelsen går i gang.',
    },
    {
      title: 'Fremdrift, der holder',
      text: 'Vi planlægger realistisk, møder med den aftalte bemanding og arbejder efter projektets samlede tidsplan.',
    },
    {
      title: 'Hurtig og løsningsorienteret dialog',
      text: 'Vi reagerer hurtigt, varsler tidligt og bidrager aktivt, når forholdene på byggepladsen ændrer sig.',
    },
    {
      title: 'Dokumenteret aflevering',
      text: 'Vi kvalitetssikrer løbende, så fejl, mangler og dokumentation håndteres inden den endelige aflevering.',
    },
  ],
  ctaHeading: 'Har I brug for en fagentreprenør, der møder forberedt og holder tempoet?',
  ctaLabel: 'Book en projektdialog',
  ctaPath: '/kontakt',
};

/* ---------------- DOKUMENTATION & KVALITET ---------------- */

export const documentationPage = {
  eyebrow: 'Dokumentation & kvalitet',
  title: 'Kvalitetssikring fra første registrering til endelig aflevering',
  image: images.sterile,
  intro:
    'Kvalitetssikring, dokumentation og sikkerhed er ikke noget, vi tilføjer til sidst. Det er integreret i vores proces fra første registrering til endelig aflevering, så der er klarhed over det, der er udført, dokumenteret og afleveret.',
  processEyebrow: 'Vores proces',
  processTitle: 'Fra første registrering til endelig aflevering',
  steps: [
    {
      no: '01',
      title: 'Registrering',
      text: 'Vi registrerer forudsætninger, tegningsgrundlag, grænseflader og forhold, der skal afklares inden opstart.',
    },
    {
      no: '02',
      title: 'Planlægning',
      text: 'Vi fastlægger proces, tidsplan og ansvarsområder sammen med projektledelsen og de relevante fag.',
    },
    {
      no: '03',
      title: 'Udførelse',
      text: 'Vi udfører entreprisen efter det aftalte projektgrundlag med løbende egenkontrol og koordinering.',
    },
    {
      no: '04',
      title: 'Kvalitetssikring',
      text: 'Vi samler dokumentation og håndterer afvigelser løbende, så der er sporbarhed gennem hele forløbet.',
    },
    {
      no: '05',
      title: 'Aflevering',
      text: 'Vi afleverer struktureret og gennemgår det udførte arbejde og den tilhørende dokumentation med kunden.',
    },
  ],
  cta: {
    title: 'Skal vi tale om jeres næste projekt?',
    label: 'Book en projektdialog',
    path: '/kontakt',
  },
};
